<template>
  <div>
    <div v-if="hasResults">
      <div
        v-for="(item, index) in results"
        :key="index"
        class="mb-3 custom-callout "
        :controlled="false"
      >
        <div class="row border-bottom bg-gray p-3  mt-3">
          <div class="col-sm col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Estatus:
            </div>
            <div class="mt-2 d-flex align-items-center">
              <div
                class="status-balloon-container w-unset"
                :style="{ 'background-color': item.statusColor }"
              ></div>
              <span class="font-weight-bold">
                {{ item.status | empty }}
              </span>
            </div>
          </div>
          <div class="col-sm col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal mr-2">
              Nombre de Equipo:
            </div>
            <div class="color-black font-16">
              {{ item.equipmentName | empty }}
            </div>
          </div>
          <div class="col-sm col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal mr-2">
              Ubicación:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ item.location | empty }}
            </div>
          </div>
          <div class="col-sm col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal mr-2">
              Fecha de Asignación:
            </div>
            <div class="color-black font-16 font-weight-normal">
              {{ item.assignedDate | date }}
            </div>
          </div>
        </div>
      </div>

      <pagination
        v-if="pagination.totalItemCount > pagination.pageSize"
        :data="pagination"
        :page-size="pagination.pageSize"
        @pagination-go-page="onPageChange"
      />
    </div>
    <custom-result-not-found v-else text="No hay Información Disponible." />
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import Pagination from 'pagination';

import service from '@/services/api/inventorycatalog.api';

export default {
  name: 'AccessoryLocations',
  components: {
    CustomResultNotFound,
    Pagination,
  },
  props: {
    detailId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasResults() {
      return Boolean(this.results?.length);
    },
  },
  data: () => ({
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 5,
    },
    results: [],
  }),
  async mounted() {
    await this.search(1);
  },
  methods: {
    async onPageChange(page) {
      this.search(page);
    },
    async search(page = 1) {
      const { data: result } = await service.getAccessoryLocations(
        this.detailId,
        page,
        this.pagination.pageSize
      );

      this.results = result.data;

      this.pagination = {
        pageSize: 5,
        totalItemCount: result.totalItemCount,
        pageCount: result.pageCount,
        currentPage: result.currentPage,
        count: result.count,
      };
    },
  },
};
</script>

<style lang="scss">
.status-balloon-container {
  margin-right: 10px;
  padding: 5px;
  text-align: center;
  color: #11291b;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 900;
  width: 100%;
  width: unset;
}
</style>
